import React from "react";
import { useTranslation } from "react-i18next";
import { FormControl, InputLabel, Select } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import { SelectChangeEvent } from "@mui/material/Select";
import {
  ALL_WRITING,
  NONE_LITERATE_WRITING,
} from "../../../../utils/AccountingSituationUtils";
import { useSearchParams } from "react-router-dom";
import { searchParamToObject } from "../../../../helpers/SearchParamHelper";

const LetteringFormComponent: React.FC = React.memo(() => {
  const defaultValue = NONE_LITERATE_WRITING;
  const [searchParams, setSearchParams] = useSearchParams();
  const { t } = useTranslation();
  const getValue = React.useCallback(() => {
    const searchParamsObject = searchParamToObject(searchParams);
    if (searchParamsObject.hasOwnProperty("lettering")) {
      return searchParamsObject.lettering;
    }
    return defaultValue;
  }, [defaultValue, searchParams]);
  const [value, setValue] = React.useState(getValue());
  const handleChangeSelect = React.useCallback(
    (event: SelectChangeEvent) => {
      const searchParamsObject = searchParamToObject(searchParams);
      setValue(event.target.value as string);
      searchParamsObject.lettering = event.target.value as string;
      setSearchParams(searchParamsObject, {
        replace: true,
      });
    },
    [searchParams, setSearchParams]
  );

  const init = React.useCallback(() => {
    const searchParamsObject = searchParamToObject(searchParams);
    if (!searchParamsObject.hasOwnProperty("lettering")) {
      searchParamsObject.lettering = defaultValue;
      setSearchParams(searchParamsObject, {
        replace: true,
      });
    }
  }, [defaultValue, searchParams, setSearchParams]);

  React.useEffect(() => {
    init();
  }, [searchParams]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <FormControl fullWidth>
      <InputLabel id="lettering">{t("field.lettering")}</InputLabel>
      <Select
        labelId="lettering"
        value={value}
        label={t("field.lettering")}
        onChange={handleChangeSelect}
      >
        {ALL_WRITING.map((writing, indexWriting) => (
          <MenuItem value={writing} key={indexWriting}>
            {t("word.accountingSituation.lettering." + writing)}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
});

export default LetteringFormComponent;
